let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page000_game6/img/bcg.jpg',
    pos: {
      x: 183,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page000_game6/audio/42_jump.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game6/img/audioOn.png', iconOff: 'games/page000_game6/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 315,
        x: 515,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game6/audio/40_run.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game6/img/audioOn.png', iconOff: 'games/page000_game6/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 5,
        x: 945,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game6/audio/37_catch.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game6/img/audioOn.png', iconOff: 'games/page000_game6/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 275,
        x: 1445,
      },
      unit: 'px',
    },
  ],
};

export default elements;
